const DRAFT_KEY = "managerHostDraft";

export function readManagerDraft() {
  try {
    const raw = sessionStorage.getItem(DRAFT_KEY);
    if (!raw) return null;
    return JSON.parse(raw) || null;
  } catch {
    return null;
  }
}

export function writeManagerDraft(draft) {
  sessionStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
}

export function patchManagerDraft(partial) {
  const prev = readManagerDraft() || {};
  writeManagerDraft({ ...prev, ...partial });
}
